import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { palette } from "../palette";
import { fadeUp, revealProps, stagger, useReducedMotion } from "../motion";
import { Campus } from "../illustrations/Campus";

const PARAGRAPHS = [
  "We're a small group of AI engineers, data scientists and founders. We've spent years building AI systems, and years teaching people to build them.",
  "It's the same few of us the whole way through. We'll know your plan because we helped write it, and we'll remember where you got stuck last week.",
];

export const WhoWeAre = () => {
  const reduced = useReducedMotion();

  return (
    <Box
      component="section"
      id="who-we-are"
      aria-labelledby="who-we-are-heading"
      sx={{ py: { xs: 8, md: 13 }, backgroundColor: palette.bgAlt }}
    >
      <Container maxWidth="md">
        <motion.div variants={stagger(0.1)} {...revealProps(reduced)}>
          <motion.div variants={fadeUp}>
            <Typography
              component="p"
              sx={{
                color: palette.primary,
                fontWeight: 600,
                fontSize: 13,
                letterSpacing: "0.08em",
                textTransform: "uppercase",
                mb: 1.5,
              }}
            >
              Who we are
            </Typography>
          </motion.div>

          <motion.div variants={fadeUp}>
            <Typography
              component="h2"
              id="who-we-are-heading"
              sx={{
                color: palette.text,
                fontWeight: 700,
                letterSpacing: "-0.03em",
                lineHeight: 1.12,
                fontSize: { xs: 30, sm: 38, md: 44 },
                mb: 3.5,
              }}
            >
              People who build this, and like teaching it
            </Typography>
          </motion.div>

          {PARAGRAPHS.map((text) => (
            <motion.div variants={fadeUp} key={text}>
              <Typography
                component="p"
                sx={{
                  color: palette.textMuted,
                  fontSize: { xs: 17, md: 18.5 },
                  lineHeight: 1.72,
                  mb: 2.5,
                }}
              >
                {text}
              </Typography>
            </motion.div>
          ))}

          {/* The intention, said plainly and left to stand on its own. */}
          <motion.div variants={fadeUp}>
            <Typography
              component="p"
              sx={{
                color: palette.text,
                fontSize: { xs: 19, md: 23 },
                lineHeight: 1.6,
                fontWeight: 600,
                letterSpacing: "-0.02em",
                borderLeft: `3px solid ${palette.primary}`,
                pl: 3,
                mt: 4.5,
              }}
            >
              We do this because we love it. We want to teach it properly, to
              people who genuinely want to learn — and stay with them until
              they get there.
            </Typography>
          </motion.div>

          <motion.div variants={fadeUp}>
            <Box sx={{ mt: { xs: 5, md: 7 } }}>
              <Campus />
            </Box>
          </motion.div>
        </motion.div>
      </Container>
    </Box>
  );
};

export default WhoWeAre;
